import api from '../index';

const baseUrl = '/vehicle';

export const createVehicleApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create-vehicle`,
    data,
  });
};

export const updateVehicleApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/update-vehicle`,
    data,
  });
};

export const deleteVehicleApi = (id) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-vehicle/${id}`,
  });
};

export const getVehicleList = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-vehicles?${query}`,
  });
};

export const getSignleVehicle = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/get-vehicle`,
    data,
  });
};

export const exportVehicleApi = (query) => {
  return api({
    method: 'post',
    url: `${baseUrl}/export-vehicle?${query}`,
  });
};

export const getvehicleImagesApi = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-single-vehicle-images/${id}`,
  });
};

export const attachVehicleToCustomer = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/attach-vehicle-to-customer`,
    data,
  });
};

export const searchVehicleApi = ({
  searchValue,
  searchType,
  vehicleWithNoCustomer = false,
}) => {
  return api({
    method: 'get',
    url: `${baseUrl}/search?searchValue=${searchValue}&searchType=${searchType}&vehicleWithNoCustomer=${vehicleWithNoCustomer}`,
  });
};

export const importVehicleApi = (file, handleUploadProgress) => {
  return api({
    method: 'post',
    url: `${baseUrl}/import-vehicle-file`,
    data: file,
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      const percent = Math.floor((loaded * 100) / total);
      handleUploadProgress(percent);
    },
  });
};
